export interface Folder {
  id: number
  accountId: number
  name: string
  description: string | null
}

export interface Settings {
  id: number
  templateId: number
  requireIdentifier: number | null
  requireApproval: number | null
  createdAt: string | null
  updatedAt: string | null
}

export type Integration =
  | 'adobe-experience-manager-inbound'
  | 'adobe-experience-manager-outbound'
  | 'adobe-inbound'
  | 'adobe-outbound'
  | 'aws-s3-inbound'
  | 'azure-blob-push'
  | 'bitly'
  | 'box-push-general'
  | 'box-push'
  | 'branch'
  | 'email-output'
  | 'facebook-ads-update'
  | 'facebook-ads'
  | 'ftp-push'
  | 'google-analytics'
  | 'google-cloud'
  | 'google-dcm-output'
  | 'google-dcm'
  | 'NOOP'
  | 'qr-code-monkey'
  | 's3-push'
  | 'salesforce-inbound'
  | 'sftp-pull'
  | 'sftp-push'
  | 'webhook'
  | 'workfront-project-pull'
  | 'facebook-marketing-inbound'
/*
  We are shifting to the word datasets when referring to templates for users.
  This Dataset interface maps directly to the TemplateDto defined in aimia.
*/
export interface Dataset {
  id: number
  name: string
  description: string | null
  folderId: number
  rollupDatasetId: number | null
  lastSubmissionTime: string | null
  createdAt: string
  updatedAt: string | null
  deletedAt: string | null
  favorite: boolean
  rowCount: number | null
  folder: Folder | null
  settings: Settings
  integrations: Integration[]
}

export enum SortBy {
  RECENT = 'Recent',
  ALPHABETICAL_ASC = 'Alphabetical (A-Z)',
  ALPHABETICAL_DESC = 'Alphabetical (Z-A)',
}

export interface FolderOption {
  id: number | string
  value: string
  text: string
}

export type MoreMenuItems = {
  Icon?: React.ElementType
  name: string
  createLink?: (id: number) => string
  callback?: (() => void) | null
}[]

// TODO: don't use enums like this
export enum Query {
  TEMPLATES = 'getTemplates',
  FOLDERS = 'getFolders',
}
